import { log } from "@antv/g2plot/lib/utils";
import { types } from "../action-types";

const initialState = {

    loading: false,
    error: false,
    DraftList: [],
    jobs: [],
    response: [],
    jobdetails: [],
    error: {},
    loadingDraft: false,

};

const manageDraftJobsReducer = (state = initialState, action) => {
    switch (action.type) {

        case types.GET_JOB_LISTING_DRAFT:
            return {
                ...state,
                loading: true,
                // del_success: false,
            }
        case types.GET_JOB_LISTING_DRAFT_SUCCESS:
            return {
                ...state,
                loading: false,
                jobs: action.payload,
                error: false,
            }
        case types.GET_JOB_LISTING_DRAFT_FAILURE:
            return {
                ...state,
                loading: false,
                jobs: [],
                error: true,
            }
        case types.GET_JOB_RESULT_LISTING_DRAFT:
            return {
                ...state,
                loadingDraft: true,
            }
        case types.GET_JOB_RESULT_LISTING_SUCESS_DRAFT:
            return {
                ...state,
                loadingDraft: false,
                loading: false,
                DraftList: action.payload,
            }
        case types.GET_JOB_LISTING_DRAFT_RESET:
            return {
                ...state,
                jobs: [],

            };

        // fetchAlGigs reducer       
        // case types.FETCH_GIGSALL_REQUESTED:
        //     return {
        //         ...state,
        //         loading: true,
        //         expiry_success: false,
        //         del_success: false,
        //         response: [],
        //         jobs: [],
        //     };

        // case types.FETCH_GIGSALL_SUCCESS:
        //     return {
        //         ...state,
        //         loading: false,
        //         jobs: action.payload,
        //         del_success: false,
        //         expiry_success: false,
        //         error: false,
        //     };
        // case types.FETCH_GIGSALL_FAILURE:
        //     return {
        //         ...state,
        //         loading: false,
        //         jobs: [],
        //         error: true,
        //     };



        // getJobdetails reducer
        case types.GET_JOBDETAIL_REQUESTED:
            return {
                ...state,
                loading: true,
                expiry_success: false,
            };

        case types.CLEAR_JOB_DELETE_SUCCESS:
            return {
                ...state,
                del_success: false, 
                response: [],
            };

        case types.GET_JOBDETAIL_SUCCESS:
            return {
                ...state,
                loading: false,
                jobdetails: action.payload,
                error: false,
            };
        case types.GET_JOBDETAIL_FAILURE:
            return {
                ...state,
                loading: false,
                jobdetails: [],
                error: true,
            };

        // updateJob reducer
        case types.UPDATE_GIG_REQUESTED:
            return {
                ...state,
                loading: true,
                expiry_success: false,
                del_success: false,
            };

        case types.UPDATE_GIG_SUCCESS:
            return {
                ...state,
                loading: false,
                expiry_success: true,
                error: false,
                response: action.payload
            };
        case types.UPDATE_GIG_FAILURE:
            return {
                ...state,
                loading: false,
                expiry_success: false,
                error: true,
            };


        // deleteJob reducer

        case types.DELETE_JOB_REQUESTED:
            return {
                ...state,
                loading: true,
                expiry_success: false,
                del_success: false,
                response:[]
            };

        case types.DELETE_JOB_SUCCESS:
            return {
                ...state,
                loading: false,
                expiry_success: false,
                del_success: true,
                error: false,
                response: action.payload
            };
        case types.DELETE_JOB_FAILURE:
            return {
                ...state,
                loading: false,
                // del_success: false,
                expiry_success: false,
                error: true,
                response: []
            };
            case types.DELETE_JOB_RESET:
                return {
                    ...state,
                    loading: false,
                    del_success: false,
                    response: []
                };


        // default case
        default:
            return state;

    }
};

export default manageDraftJobsReducer;
